import React from 'react'
import PropTypes from 'prop-types'
import { clampPercent } from 'state/utils'

function SingleStackedBar({secondary, percent}) {

  const className = secondary
  ? 'SingleStackedBar SingleStackedBar--secondary'
  : 'SingleStackedBar'

  return (
    <div className={className}>
      <div style={{width: `${clampPercent(percent) * 100}%`}} className="SingleStackedBar__primary"></div>
    </div>
  )
}


export default SingleStackedBar


// WEBPACK FOOTER //
// ./sections/wealth-breakdown/single-stacked-bar.js